import api from "../../../api/axios";

const propertyLandParcelsUrl = (propertyId) =>
  `/realty/properties/${propertyId}/land-parcels/`;

const landParcelUrl = (propertyId, parcelId) =>
  `/realty/properties/${propertyId}/land-parcels/${parcelId}/`;

export const listLandParcels = (propertyId) =>
  api.get(propertyLandParcelsUrl(propertyId)).then((response) => response.data);

export const createLandParcel = (propertyId, payload) =>
  api
    .post(propertyLandParcelsUrl(propertyId), payload)
    .then((response) => response.data);

export const patchLandParcel = (propertyId, parcelId, payload) =>
  api
    .patch(landParcelUrl(propertyId, parcelId), payload)
    .then((response) => response.data);

export const deleteLandParcel = (propertyId, parcelId) =>
  api.delete(landParcelUrl(propertyId, parcelId)).then((response) => response.data);
